/* import __COLOCATED_TEMPLATE__ from './reaction-picker.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();